var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArtGeneratorCopy = function SvgIconArtGeneratorCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 7.334c0-1.886 0-2.83.586-3.414.585-.586 1.529-.586 3.414-.586h2c1.885 0 2.829 0 3.414.586C14 4.505 14 5.448 14 7.334v3.333c0 1.885 0 2.829-.586 3.414-.585.586-1.529.586-3.414.586H8c-1.885 0-2.829 0-3.414-.586C4 13.496 4 12.552 4 10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12.667a2 2 0 0 1-2-2v-4c0-2.514 0-3.771.781-4.552.782-.78 2.038-.782 4.552-.782H10a2 2 0 0 1 2 2"
  }))));
};
export default SvgIconArtGeneratorCopy;